import React from 'react';
import { connect } from 'react-redux';
import { findSelectedInCategory } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import urls, { codeUrl } from '@/constants/urls';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import CreateAction from '@/components/ribbon-actions/CreateAction';
import { refreshCohorts, confirmCohortsDeletion } from '../actions';
import { cohortPermissions } from '../constants';

const CohortsActions = ({
  allowCreate,
  allowDelete,
  allowRefresh,
  category,
  code,
  disableDelete,
  readStatus,
  refresh,
  showDelete,
}) => (
  <>
    {allowCreate && (<CreateAction url={codeUrl(urls.COHORT, code, '#')} />)}
    {allowRefresh && (<RefreshActionMenu onClick={() => refresh(category, 1)} readStatus={readStatus} />)}
    {allowDelete && (<DeleteActionMenu onClick={() => showDelete(category)} disabled={disableDelete} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions } },
  cohorts: { cohorts, newCohortCode },
}, { category }) => {
  const { readStatus } = cohorts[category];
  const selected = findSelectedInCategory(cohorts, category);
  const denyDestroy = selected.some((cohort) => !cohort.permissions[cohortPermissions.DESTROY]);

  return {
    allowCreate: permissions.cohorts.create,
    allowDelete: permissions.cohorts.destroy,
    allowRefresh: permissions.cohorts.read,
    disableDelete: denyDestroy || readStatus === states.PENDING || selected.length === 0,
    code: newCohortCode,
    readStatus,
  };
};

const mapDispatchToProps = {
  refresh: refreshCohorts,
  showDelete: confirmCohortsDeletion,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortsActions);
